module.exports = __webpack_public_path__ + "img/L3A.43197244.jpg";